<template>
  <v-dialog v-model="dialog" persistent="persistent" max-width="450px">
    <v-card grid-list-md>
      <ModelTitle title="Add Screen" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined autofocus :hide-details="nameErrors.length === 0" dense :error-messages="nameErrors"
              v-model="screen.name" label="Name"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-switch class="pa-0 ma-0" v-model="screen.isActive" label="Active Status"> </v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="save()"
          >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import screenService from '@/modules/MasjidImage/Screen/service.js';
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    createDialog: {
      default: false,
    },
  },
  name: 'create-screen',
  data() {
    return {
      dialog: false,
      loading: false,
      screen: {
        isActive: true,
        name: null
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    screen: {
      name: {
        required,
      },
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.screen.name.$dirty) return errors;
      if (!this.$v.screen.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    },
  },
  methods: {
    empty() {
      this.screen =  {
        isActive: true,
        name: null,
      },
      this.$v.$reset()
    },
    close() {
      this.empty();
      this.$emit('close');
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return screenService.create(this.screen)
          .then((result) => {
            console.log('result', result)
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: 'screen created!',
                });
              this.loading = false;  
              this.empty();
              this.$emit('createdScreen');
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log('err', err)
            this.$swal
              .mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                type: 'error',
                title: err.data.data,
              });
          });
      }
    },
  },
};
</script>
